import { render } from "./PoolUserDashboard.vue?vue&type=template&id=5a047988&scoped=true&ts=true"
import script from "./PoolUserDashboard.vue?vue&type=script&lang=ts"
export * from "./PoolUserDashboard.vue?vue&type=script&lang=ts"

import "./PoolUserDashboard.vue?vue&type=style&index=0&id=5a047988&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a047988"]])

export default __exports__